import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {requestShipmentData} from "../../actions/shipmentDataActions";
import BackgroundColorMobile from './../BackgroundColorMobile/BackgroundColorMobile';
import {NavLink} from 'react-router-dom';
import {getHours, getAMorPM, getTimeZone} from './../../shared/dateFormatter';
import {getLotStatus} from './../../shared/lotStatus';
import {getDescriptionForAWBStatus} from "../../shared/awbStatus";


class TrackingResults extends Component {
    constructor(props) {
        super(props);
        this.state = {
            simplifiedResultsToDisplay: [],
            sortColumn: 'awbNumber',
            sortDirection: 'asc'
        };
    };

    componentDidMount() {
        if (this.props.requestedShipmentData === false) {
            // Call api to request shipment data because shipment data was not requested
            const querystringParams = queryString.parse(this.props.location.search);
            const trackingInfoParam = querystringParams.trackingInfo;
            let trackingInfoToSend = [];
            if (trackingInfoParam !== undefined) {
                let trackingInfoData = trackingInfoParam.split(',');
                for (let i = 0; i < trackingInfoData.length; i++) {
                    // The data should come as airlineCode - trackingNumber
                    const trackingInfoSplittedData = trackingInfoData[i].split('-');
                    if (trackingInfoSplittedData.length === 2) {
                        let trackingInfo = {airlineCode: trackingInfoSplittedData[0], trackingNumber: trackingInfoSplittedData[1]};
                        trackingInfoToSend.push(trackingInfo);
                    }
                }
            }
            if (trackingInfoToSend.length > 0) {
                this.props.requestShipmentData(trackingInfoToSend, {nextUrl: this.props.location.pathname});
            }
        }
        this.simplifyResults();
    }

    //TODO: Refactor later as this is deprecated method
    // https://reactjs.org/docs/react-component.html#unsafe_componentwillreceiveprops
    componentWillReceiveProps(nextProps) {
        if (nextProps.shipmentData !== undefined && nextProps.shipmentData.length > 0) {
            this.simplifyResults();
        }
    };


    simplifyResults = () => {
        let shippingResultsToDisplay = [];
        let count = 1;


        // eslint-disable-next-line
        this.props.shipmentData.forEach(shipment => {
            const routeInformation = shipment.routeInformations || shipment.routeInformation;
            if (routeInformation && Array.isArray(routeInformation)) {
                routeInformation.forEach(route => {
                const shipping = {
                    id: count,
                    awbPrefix: shipment.awbPrefix,
                    awbNumber: shipment.awbNumber,
                    awbStatus: getDescriptionForAWBStatus(shipment.awbstatus),
                    origin: shipment.origin.code,
                    destination: shipment.destination.code,
                    originDestination: shipment.origin.code + ' ' + shipment.destination.code,
                    tenderedAtOrigin: new Date(shipment.tenderedDate),
                    tenderedAtOriginRaw: shipment.tenderedDate,
                    lot: route.lotNumber,
                    arrivedAtDestination: this.getArrivedAtDestination(routeInformation, route.lotNumber),
                    arrivedAtDestinationRaw: this.getArrivedAtDestinationRaw(routeInformation, route.lotNumber),
                    lotStatus: getLotStatus(route.currentLotStatus),
                    numberOfPieces: route.noOfPieces,
                    pickUpCustomer: route.deliveredToCustomer,
                    chargeableWeight: shipment.chargeableWeight,
                    chargeableWeightUOM: shipment.chargeableWeightUOM,
                    actualWeight: route.actualWeight,
                    actualWeightUOM: route.actualWeightUOM,
                    isExpanded: false
                };
                    shippingResultsToDisplay.push(shipping);
                    count++;
                });
            }
        });

        shippingResultsToDisplay.sort(function (a, b) {
            return a.awbNumber - b.awbNumber;
        });

        this.setState({
            simplifiedResultsToDisplay: shippingResultsToDisplay
        });
    };

    getLotToDisplay = (routeInfoList, lotNumber) => {
        let routeInfo;
        for (let i = 0; i < routeInfoList.length; i++) {
            if (routeInfoList[i].lotNumber === lotNumber) {
                routeInfo = routeInfoList[i];
                break;
            }
        }
        if (typeof routeInfo === "undefined" || routeInfo === null || routeInfo.length === 0)
            return;

        return routeInfo;
    };

    getLotNumber = (routeInfoList, lotNumber) => {
        const routeInfo = this.getLotToDisplay(routeInfoList, lotNumber);
        if (routeInfo === undefined || routeInfo === null)
            return;
        return routeInfo.lotNumber;
    };

    getNumberOfPieces = (routeInfoList, lotNumber) => {
        const routeInfo = this.getLotToDisplay(routeInfoList, lotNumber);
        if (routeInfo === undefined || routeInfo === null)
            return;
        return routeInfo.noOfPieces;
    };

    getArrivedAtDestinationRaw = (routeInfoList, lotNumber) => {
        const routeInfo = this.getLotToDisplay(routeInfoList, lotNumber);
        if (routeInfo === undefined || routeInfo === null)
            return;
        return routeInfo.receivedDate;
    };

    getArrivedAtDestination = (routeInfoList, lotNumber) => {
        const routeInfo = this.getLotToDisplay(routeInfoList, lotNumber);
        if (routeInfo === undefined || routeInfo === null)
            return;
        if (routeInfo.receivedDate === null || routeInfo.receivedDate === undefined)
            return;

        return new Date(routeInfo.receivedDate);
    };

    getLotStatusFromRouteInfo = (routeInfoList, lotNumber) => {
        const routeInfo = this.getLotToDisplay(routeInfoList, lotNumber);
        if (routeInfo === undefined || routeInfo === null)
            return;
        return routeInfo.currentLotStatus;
    };

    getPickUpCustomer = (routeInfoList, lotNumber) => {
        const routeInfo = this.getLotToDisplay(routeInfoList, lotNumber);
        if (routeInfo === undefined || routeInfo === null)
            return;
        return routeInfo.deliveredToCustomer;
    };


    sortResults = (sortColumn, sortDirection) => {
        let results = this.state.simplifiedResultsToDisplay;
        if (sortDirection === 'asc') {
            if (sortColumn === 'lotStatus' || sortColumn === 'originDestination') {
                results.sort(function (a, b) {
                    return a[sortColumn].localeCompare(b[sortColumn]);
                });
            } else {
                results.sort(function (a, b) {
                    return a[sortColumn] - b[sortColumn];
                });
            }

        } else {
            if (sortColumn === 'lotStatus' || sortColumn === 'originDestination') {
                results.sort(function (a, b) {
                    return b[sortColumn].localeCompare(a[sortColumn]);
                });
            } else {
                results.sort(function (a, b) {
                    return b[sortColumn] - a[sortColumn];
                });
            }
        }
        this.setState({
            simplifiedResultsToDisplay: results,
            sortColumn: sortColumn,
            sortDirection: sortDirection
        });
    };

    getCSSForSortIconAsc = (sortColumn) => {
        if (this.state.sortColumn === sortColumn && this.state.sortDirection === 'asc')
            return "tracking-results__sort";
        else
            return "tracking-results-sort__hide";
    };

    getCSSForSortIconDesc = (sortColumn) => {
        if (this.state.sortColumn === sortColumn && this.state.sortDirection === 'desc')
            return "tracking-results__sort";
        else
            return "tracking-results-sort__hide";
    };

    changeSortColumn = (sortColumn) => {
        let sortDirection = 'asc';
        if (this.state.sortColumn === sortColumn) {
            if (this.state.sortDirection === 'asc') {
                sortDirection = 'desc';
            }
        }
        this.setState({
            sortColumn: sortColumn,
            sortDirection: 'asc'
        });
        this.sortResults(sortColumn, sortDirection);
    };

    getDateStringFromRawDateString = (date) => {
        if (date !== null && date.length > 0) {
            const dateSubStr = date.slice(0, 10);
            return dateSubStr;
        }
        return '';
    };

    getWeightString(weight, uom) {

        let w = weight ? weight : "";
        let u = uom ? uom.toLowerCase() : "";

        return w + " " + u;

    }

    getCSSForCollapse = (id) => {
        const index = this.state.simplifiedResultsToDisplay.findIndex((result) => result.id === id);
        if (this.state.simplifiedResultsToDisplay[index].isExpanded) {
            return "tracking-results-data__chevron tracking-results-data-chevron__hide";
        } else {
            return "tracking-results-data__chevron";
        }
    };

    getCSSForExpand = (id) => {
        const index = this.state.simplifiedResultsToDisplay.findIndex((result) => result.id === id);
        if (this.state.simplifiedResultsToDisplay[index].isExpanded) {
            return "tracking-results-data__chevron";
        } else {
            return "tracking-results-data__chevron tracking-results-data-chevron__hide";
        }
    };

    getCSSForExpandHideDetails = (id) => {
        const index = this.state.simplifiedResultsToDisplay.findIndex((result) => result.id === id);
        if (this.state.simplifiedResultsToDisplay[index].isExpanded) {
            return "tracking-results-data-hide-details__chevron";
        } else {
            return "tracking-results-data-hide-details__chevron tracking-results-data-chevron__hide";
        }
    };

    getCSSForDetails = (id) => {
        const index = this.state.simplifiedResultsToDisplay.findIndex((result) => result.id === id);
        if (this.state.simplifiedResultsToDisplay[index].isExpanded) {
            return "tracking-results-data__details";
        } else {
            return "tracking-results-data__details tracking-results-data-details__hide";
        }
    };

    expandDetails = (id) => {
        const index = this.state.simplifiedResultsToDisplay.findIndex((result) => result.id === id);
        let results = [...this.state.simplifiedResultsToDisplay];
        results[index].isExpanded = true;
        this.setState({simplifiedResultsToDisplay: results});
    };

    collapseDetails = (id) => {
        const index = this.state.simplifiedResultsToDisplay.findIndex((result) => result.id === id);
        let results = [...this.state.simplifiedResultsToDisplay];
        results[index].isExpanded = false;
        this.setState({simplifiedResultsToDisplay: results});
    };

    getStyleForErrorMessage = () => {
        if (this.props.notFoundTrackingIds.length > 0) {
            return "alert alert-danger tracking-results-not-found-error-wrapper";
        } else {
            return "racking-results-not-found-error-wrapper__hide";
        }
    };

    getErrorMessage = () => {
        let errorString = '';
        if (this.props.notFoundTrackingIds.length > 0) {
            errorString = "The following air waybill numbers were not found, please review the numbers and try again:"
        }
        return errorString;
    };

    getNotFoundTrackingIds = () => {
        let trackingIds = '';
        this.props.notFoundTrackingIds.forEach(trackingId => {
            trackingIds += trackingId + ', ';
        });
        if (trackingIds.length > 1) {
            trackingIds = trackingIds.slice(0, trackingIds.length - 2);
        }
        return trackingIds;
    };

    getCSSForWrapper = (id) => {
        const index = this.state.simplifiedResultsToDisplay.findIndex((result) => result.id === id);
        if (this.state.simplifiedResultsToDisplay[index].isExpanded === true) {
            return "tracking-results-data-wrapper tracking-results-data-wrapper-no-bottom-padding";
        } else {
            return "tracking-results-data-wrapper ";
        }
    };

    handleEditSearch = () => {
        this.props.history.push({
            pathname: '/manage/tracking',
            search: this.getQueryStringParams()
        });
    };

    handleTrackingDetailPath = () => {
        return this.props.location.pathname + '/tracking-details';
    };

    getQueryStringParams = () => {
        return this.getNotFoundIds() + this.getFoundIds();
    };

    getNotFoundIds = () => {
        let trackingIds = '';
        if (this.props.notFoundTrackingIds) {
            trackingIds += 'invalidIds=';
            this.props.notFoundTrackingIds.forEach(function (trackingId, index, array) {
                if (index === array.length - 1)
                    trackingIds += trackingId;
                else
                    trackingIds += trackingId + ',';
            })
        }
        return trackingIds;
    };

    getFoundIds = () => {
        let trackingIds = '';
        if (this.props.shipmentData) {
            this.props.shipmentData.forEach(function (tracking, index, array) {
                if (index === 0)
                    trackingIds += '&validIds=';
                trackingIds += tracking.awbPrefix + '-' + tracking.awbNumber;
                if (index < array.length - 1)
                    trackingIds += ',';
            });
        }
        return trackingIds;
    };

    render() {
        return (
                <div>
                    <div className="tracking-results__title">Tracking Results</div>
                    <div className="tracking-results-print" onClick={() => window.print()}>
                        <img src="./assets/icons/print.svg" alt="Print" className="tracking-results-print__img"/>
                        Print
                    </div>

                    <div className={this.getStyleForErrorMessage()}>
                        <div className="tracking-results-not-found-error">
                            <div> {this.getErrorMessage()} </div>

                            <div> {this.getNotFoundTrackingIds()} </div>
                        </div>
                        <div className="tracking-results-try-again">
                            <button className="tracking-results-try-again__button" onClick={this.handleEditSearch}> Edit Search</button>
                        </div>
                    </div>

                    <div className="tracking-results-wrapper-dektop">
                        <div>
                            <div
                                    className="tracking-results__column tracking-results-columm__header tracking-results-column__airwaybill"
                                    onClick={() => this.changeSortColumn('awbNumber')}>
                                <span className="tracking-results-sort__text text-uppercase">Air Waybill # </span>
                                <div className={this.getCSSForSortIconAsc('awbNumber')}>
                                    <img src="./assets/icons/sort-ascending.svg" alt="sort ascending"
                                         className="tracking-results-sort__img"/>
                                </div>
                                <div className={this.getCSSForSortIconDesc('awbNumber')}>
                                    <img src="./assets/icons/sort-descending.svg" alt="sort descending"
                                         className="tracking-results-sort__img"/>
                                </div>
                            </div>
                            <div className="tracking-results__column tracking-results-columm__header tracking-results-column__lot"
                                 onClick={() => this.changeSortColumn('lot')}>
                                <span className="tracking-results-sort__text text-uppercase"> Lot </span>
                                <div className={this.getCSSForSortIconAsc('lot')}>
                                    <img src="./assets/icons/sort-ascending.svg" alt="sort ascending"
                                         className="tracking-results-sort__img"/>
                                </div>
                                <div className={this.getCSSForSortIconDesc('lot')}>
                                    <img src="./assets/icons/sort-descending.svg" alt="sort descending"
                                         className="tracking-results-sort__img"/>
                                </div>
                            </div>
                            <div
                                    className="tracking-results__column tracking-results-columm__header tracking-results-column__OriginAndDestination"
                                    onClick={() => this.changeSortColumn('originDestination')}>
                                <span className="tracking-results-sort__text text-uppercase">Origin & Destination </span>
                                <div className={this.getCSSForSortIconAsc('originDestination')}>
                                    <img src="./assets/icons/sort-ascending.svg" alt="sort ascending"
                                         className="tracking-results-sort__img"/>
                                </div>
                                <div className={this.getCSSForSortIconDesc('originDestination')}>
                                    <img src="./assets/icons/sort-descending.svg" alt="sort descending"
                                         className="tracking-results-sort__img"/>
                                </div>
                            </div>
                            <div
                                    className="tracking-results__column tracking-results-columm__header tracking-results-column__TenderedAtOrigin"
                                    onClick={() => this.changeSortColumn('tenderedAtOrigin')}>
                                <span className="tracking-results-sort__text text-uppercase">Tendered at origin </span>
                                <div className={this.getCSSForSortIconAsc('tenderedAtOrigin')}>
                                    <img src="./assets/icons/sort-ascending.svg" alt="sort ascending"
                                         className="tracking-results-sort__img"/>
                                </div>
                                <div className={this.getCSSForSortIconDesc('tenderedAtOrigin')}>
                                    <img src="./assets/icons/sort-descending.svg" alt="sort descending"
                                         className="tracking-results-sort__img"/>
                                </div>
                            </div>
                            <div
                                    className="tracking-results__column tracking-results-columm__header tracking-results-column__ArrivedAtDestination "
                                    onClick={() => this.changeSortColumn('arrivedAtDestination')}>
                                <span className="tracking-results-sort__text text-uppercase">Arrived at destination</span>
                                <div className={this.getCSSForSortIconAsc('arrivedAtDestination')}>
                                    <img src="./assets/icons/sort-ascending.svg" alt="sort ascending"
                                         className="tracking-results-sort__img"/>
                                </div>
                                <div className={this.getCSSForSortIconDesc('arrivedAtDestination')}>
                                    <img src="./assets/icons/sort-descending.svg" alt="sort descending"
                                         className="tracking-results-sort__img"/>
                                </div>
                            </div>
                            <div
                                    className="tracking-results__column tracking-results-columm__header tracking-results-column__lotStatus"
                                    onClick={() => this.changeSortColumn('lotStatus')}>
                                <span className="tracking-results-sort__text text-uppercase">Lot Status </span>
                                <div className={this.getCSSForSortIconAsc('lotStatus')}>
                                    <img src="./assets/icons/sort-ascending.svg" alt="sort ascending"
                                         className="tracking-results-sort__img"/>
                                </div>
                                <div className={this.getCSSForSortIconDesc('lotStatus')}>
                                    <img src="./assets/icons/sort-descending.svg" alt="sort descending"
                                         className="tracking-results-sort__img"/>
                                </div>
                            </div>
                            <div className="tracking-results__column tracking-results-column__chevron">
                                &nbsp;
                            </div>
                        </div>

                        {this.state.simplifiedResultsToDisplay.map(result => (
                                <div key={result.id}>
                                    <div>
                                        <div
                                                className="tracking-results-column__airwaybill tracking-results-column__data tracking-results-column-data__airwaybill">
                                            <NavLink to={{
                                                pathname: this.handleTrackingDetailPath(),
                                                search: 'trackingId=' + result.awbPrefix + '-' + result.awbNumber
                                            }}>
                                                {result.awbPrefix + '-' + result.awbNumber} </NavLink>
                                        </div>
                                        <div className="tracking-results-column__lot tracking-results-column__data">
                                            {result.lot}
                                        </div>
                                        <div className="tracking-results-column__OriginAndDestination tracking-results-column__data">
                                            {result.origin}
                                            <img src="./assets/icons/arrow.svg" alt="arrow"
                                                 className="tracking-results-origin-destination-arrow"/>
                                            {result.destination}
                                        </div>
                                        <div className="tracking-results-column__TenderedAtOrigin tracking-results-column__data">
                                            {this.getDateStringFromRawDateString(result.tenderedAtOriginRaw)}
                                            <div className="tracking-results-column-data__time">

                    <span
                            className="tracking-results-time">
                      {getHours(result.tenderedAtOriginRaw)} </span>

                                                {getAMorPM(result.tenderedAtOriginRaw)} {getTimeZone(result.tenderedAtOriginRaw)}
                                            </div>
                                        </div>
                                        <div className="tracking-results-column__ArrivedAtDestination tracking-results-column__data">
                                            {this.getDateStringFromRawDateString(result.arrivedAtDestinationRaw)}
                                            <div className="tracking-results-column-data__time">

                    <span
                            className="tracking-results-time">
                      {getHours(result.arrivedAtDestinationRaw)} </span>

                                                {getAMorPM(result.arrivedAtDestinationRaw)} {getTimeZone(result.arrivedAtDestinationRaw)}
                                            </div>
                                        </div>
                                        <div
                                                className="tracking-results-column__lotStatus tracking-results-column__data tracking-results-column-data__lotStatus">
                                            {result.lotStatus}
                                        </div>
                                        <div className="tracking-results-column__chevron tracking-results-column__data">
                                            <img alt="" src="./assets/icons/chevron-down.svg" className={this.getCSSForCollapse(result.id)}
                                                 onClick={() => this.expandDetails(result.id)}/>
                                            <img alt="" src="./assets/icons/chevron-up.svg" className={this.getCSSForExpand(result.id)}
                                                 onClick={() => this.collapseDetails(result.id)}/>
                                        </div>
                                    </div>


                                    <div className={this.getCSSForDetails(result.id)}>
                                        <div
                                                className="tracking-results-column__airwaybill tracking-results-column__data">
                                            &nbsp;
                                        </div>
                                        <div
                                                className="tracking-results-column__lot tracking-results-column__data tracking-results-data-details__label">
                                            PIECES
                                            <div className="tracking-results-data-details__data">
                                                {result.numberOfPieces}
                                            </div>
                                        </div>
                                        <div
                                                className="tracking-results-column__OriginAndDestination tracking-results-column__data tracking-results-data-details__label text-uppercase">
                                            Chargeable Weight
                                            <div className="tracking-results-data-details__data">
                                                {this.getWeightString(result.chargeableWeight, result.chargeableWeightUOM)}
                                            </div>
                                        </div>
                                        <div
                                                className="tracking-results-column__TenderedAtOrigin tracking-results-column__data tracking-results-data-details__label text-uppercase">
                                            Actual Weight
                                            <div className="tracking-results-data-details__data">
                                                {this.getWeightString(result.actualWeight, result.actualWeightUOM)}
                                            </div>
                                        </div>
                                        <div
                                                className="tracking-results-column__ArrivedAtDestination tracking-results-column__data tracking-results-data-details__label text-uppercase">
                                            Pickup Customer
                                            <div className="tracking-results-data-details__data">
                                                {result.pickUpCustomer}
                                            </div>
                                        </div>
                                        <div
                                                className="tracking-results-column__lotStatus tracking-results-column__data tracking-results-column-data__lotStatus ">

                                        </div>
                                    </div>

                                </div>
                        ))}
                    </div>

                    <div className="tracking-results-wrapper-small-medium-screen">
                        {this.state.simplifiedResultsToDisplay.map(result => (
                                <div key={result.id}>
                                    <div>
                                        <div className={this.getCSSForWrapper(result.id)}>

                                            <div className="tracking-results-column__data">
                                                <div className="tracking-results-column__airwaybill text-uppercase"> Air Waybill</div>
                                                <div className="tracking-results-column-data__airwaybill">
                                                    <NavLink to={{
                                                        pathname: this.handleTrackingDetailPath(),
                                                        search: 'trackingId=' + result.awbPrefix + '-' + result.awbNumber
                                                    }}>
                                                        {result.awbPrefix + '-' + result.awbNumber} </NavLink>
                                                </div>
                                            </div>

                                            <div className="tracking-results-column__data tracking-results-column__data-right ">
                                                <div className="tracking-results-data__header text-uppercase"> Lot</div>
                                                <div className="tracking-results-column-data__lot"> {result.lot} </div>
                                            </div>

                                            <div className="tracking-results-column__data ">
                                                <div className="tracking-results-column-data__originCity">
                                                    <div className="tracking-results-data__header text-uppercase"> Origin</div>
                                                    <div className="tracking-results-column-data__city"> {result.origin} </div>
                                                </div>
                                                <div className="tracking-results-column-data-airplane__img">
                                                    <img src="./assets/ship/CargoFlightSchedules/plane.svg" alt="plane"/>
                                                </div>
                                            </div>

                                            <div className="tracking-results-column__data tracking-results-column__data-right ">
                                                <div className="tracking-results-data__header text-uppercase"> Destination</div>
                                                <div className="tracking-results-column-data__city"> {result.destination} </div>
                                            </div>


                                            <div className="tracking-results-column__data tracking-results-column__data-small-screen">
                                                <div className="tracking-results-data__header text-uppercase"> Tendered at</div>
                                                <div className="tracking-results-data__header text-uppercase"> Origin</div>
                                                <div
                                                        className="tracking-results-column-data__date">{this.getDateStringFromRawDateString(result.tenderedAtOriginRaw)} </div>
                                                <div
                                                        className="tracking-results-column-data__time">
                      <span
                              className="tracking-results-time"> {getHours(result.tenderedAtOriginRaw) + " "} </span>
                                                    {getAMorPM(result.tenderedAtOriginRaw) + " " + getTimeZone(result.tenderedAtOriginRaw)}
                                                </div>
                                            </div>

                                            <div
                                                    className="tracking-results-column__data tracking-results-column__data-small-screen tracking-results-column__data-right">
                                                <div className="tracking-results-data__header text-uppercase"> Arrived at</div>
                                                <div className="tracking-results-data__header text-uppercase"> destination</div>

                                                <div
                                                        className="tracking-results-column-data__date">{this.getDateStringFromRawDateString(result.arrivedAtDestinationRaw)}</div>
                                                <div
                                                        className="tracking-results-column-data__time">
                      <span
                              className="tracking-results-time"> {getHours(result.arrivedAtDestinationRaw)} </span>

                                                    {getAMorPM(result.arrivedAtDestinationRaw)} {getTimeZone(result.arrivedAtDestinationRaw)}
                                                </div>
                                            </div>

                                            <div className="tracking-results-column__data tracking-results-column__data-medium-screen ">
                                                <div
                                                        className="tracking-results-data__header tracking-results-data__header-right-padding text-uppercase"> Tendered
                                                    at Origin
                                                </div>

                                                <div
                                                        className="tracking-results-column-data__date">{this.getDateStringFromRawDateString(result.tenderedAtOriginRaw)} </div>


                                                <div
                                                        className="tracking-results-column-data__time">
                     <span
                             className="tracking-results-time">
                       {getHours(result.tenderedAtOriginRaw)}
                       </span>

                                                    {getAMorPM(result.tenderedAtOriginRaw)} {getTimeZone(result.tenderedAtOriginRaw)}
                                                </div>
                                            </div>

                                            <div
                                                    className="tracking-results-column__data tracking-results-column__data-medium-screen tracking-results-column__data-right">
                                                <div
                                                        className="tracking-results-data__header tracking-results-data__header-right-padding text-uppercase"> Arrived
                                                    at destination
                                                </div>
                                                <div
                                                        className="tracking-results-column-data__date">{this.getDateStringFromRawDateString(result.arrivedAtDestinationRaw)}</div>
                                                <div
                                                        className="tracking-results-column-data__time">
                      <span
                              className="tracking-results-time"> {getHours(result.arrivedAtDestinationRaw)} </span>

                                                    {getAMorPM(result.arrivedAtDestinationRaw)} {getTimeZone(result.arrivedAtDestinationRaw)}

                                                </div>
                                            </div>

                                            <div className="tracking-results-column__data ">
                                                <div className="tracking-results-data__header text-uppercase"> Pickup Customer</div>
                                                <div className="tracking-results-column-data__customer">{result.pickUpCustomer}</div>
                                            </div>

                                            <div className="tracking-results-column__data tracking-results-column__data-right">
                                                <div className="tracking-results-data__header text-uppercase"> Lot Status</div>
                                                <div className="tracking-results-column-data__lotStatus">{result.lotStatus}</div>
                                            </div>

                                            <div className={this.getCSSForCollapse(result.id)} onClick={() => this.expandDetails(result.id)}>
                                                View Details
                                                <img alt="" src="./assets/icons/chevron-down.svg" className="tracking-results-data-chevron__img"/>
                                            </div>

                                        </div>
                                        <div className={this.getCSSForDetails(result.id)}>
                                            <div className="tracking-results-column__data  tracking-results-data-details__pieces">
                                                <div className="text-uppercase">
                                                    Pieces
                                                </div>
                                                <div>
                                                    {result.numberOfPieces}
                                                </div>
                                            </div>

                                            <div className="tracking-results-column__data tracking-results-data-details__chargeableWeight">
                                                <div className="text-uppercase"> Chargeable Weight</div>
                                                <div> {this.getWeightString(result.chargeableWeight, result.chargeableWeightUOM)} </div>
                                            </div>

                                            <div className="tracking-results-column__data tracking-results-data-details__actualWeight">
                                                <div className="text-uppercase"> Actual Weight</div>
                                                <div> {this.getWeightString(result.actualWeight, result.actualWeightUOM)} </div>
                                            </div>
                                        </div>

                                        <div className={this.getCSSForExpandHideDetails(result.id)}
                                             onClick={() => this.collapseDetails(result.id)}>
                                            Hide Details
                                            <img alt="" src="./assets/icons/chevron-up.svg" className="tracking-results-data-chevron__img"/>
                                        </div>
                                    </div>

                                </div>
                        ))}
                    </div>
                    <BackgroundColorMobile/>
                </div>)
    }
};


TrackingResults.propTypes = {
    shipmentData: PropTypes.array.isRequired,
    notFoundTrackingIds: PropTypes.array.isRequired,
    requestShipmentData: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    shipmentData: state.shipmentData.items,
    notFoundTrackingIds: state.shipmentData.notFoundTrackingIds,
    requestedShipmentData: state.shipmentData.requestedShipmentData
});

export default withRouter(connect(mapStateToProps, {requestShipmentData})(TrackingResults));



// WEBPACK FOOTER //
// ./src/components/TrackingResults/TrackingResults.js